import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg'
import CtaSection from '../../components/CtaSection/CtaSection';
import icon from '../../images/icon/magic.svg'
import gImg1 from '../../images/gallery/cp-img01.jpg'
import gImg2 from '../../images/gallery/cp-img02.jpg'
import gImg3 from '../../images/gallery/cp-img03.jpg'
import gImg4 from '../../images/gallery/cp-img04.jpg'
import gImg5 from '../../images/gallery/cp-img05.jpg'
import gImg6 from '../../images/gallery/cp-img06.jpg'

const TermsPage = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <Fragment>
            <div className='body_wrap sco_agency'>
                <Header />
                <section className="page-title cp-page-title pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">
                                <div className="col-lg-8 mt-30">
                                    <div className="page-title-box">
                                        <span className="sub-title"><img src={icon} alt="" />Terms & Conditions</span>
                                        <h2 className="title">AllGuard Website Terms & Conditions - Your access and  usage rights</h2>
                                        <span className="page-update_time">Updated on : February 26th 2025</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="terms&conditions-section cp-det-bg">
                    <div className="container">
                        <div className="terms-section_inner pt-60 pb-75">
                            <div className="row">
                                <div className="col-lg-11">
                                <div className="item-details-widget">
    <h2 className="item_details_info_title">Copyright and Intellectual Property Usage</h2>
    <p>All content on the AllGuard.io website—including text, graphics, logos, and trademarks—is the intellectual property of AllGuard.io and is protected under applicable copyright, trademark, and other laws. Unauthorized use, reproduction, or distribution of this content is prohibited and may result in legal action. Third-party logos displayed on this site remain the property of their respective owners, and AllGuard.io claims no ownership over them.</p>
    <p>Users may not copy, republish, download, transmit, modify, rent, lease, sell, distribute, license, or create derivative works from any content or services on this site without prior written consent from AllGuard.io. Certain images may include licensed stock photography, to which AllGuard.io does not assert copyright ownership. All other trademarks and trade names belong to their respective owners.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Website Usage Terms</h2>
    <p>By accessing AllGuard.io, you agree to abide by these terms. Reproduction, modification, or distribution of any website content—such as text, images, graphics, videos, or audio—for public or commercial purposes without written permission is strictly prohibited and may lead to civil or criminal penalties. AllGuard.io reserves all rights not expressly granted herein.</p>
    <p>Users are prohibited from submitting or transmitting any unlawful, abusive, defamatory, or offensive material through this website. Contact information, including email addresses provided here, must not be used for unsolicited or promotional purposes.</p>
    <p>This website may include links to third-party sites. AllGuard.io is not responsible for the content, accuracy, or privacy practices of these external sites, and accessing them is at your own risk.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Software and Services</h2>
    <p>AllGuard.io provides its services on an "as-is" and "as-available" basis, subject to legally binding terms of service agreements. To use our services, you must explicitly consent to these terms, establishing a binding contract between you and AllGuard.io.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Personal Information Policy</h2>
    <p>AllGuard.io is committed to ethical practices and protects your personal information in accordance with our Privacy Policy. Please review the policy for comprehensive details on how we handle your data.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Disclaimer</h2>
    <p>The information on this website is provided in good faith and sourced from reputable providers. However, it may contain inaccuracies or errors. AllGuard.io makes no warranties, express or implied, regarding the accuracy, reliability, or suitability of the information, products, or services on this site. This content does not constitute professional advice.</p>
    <p>AllGuard.io disclaims all warranties, including fitness for a particular purpose, to the fullest extent permitted by law. Use of this site, its services, or materials is at your sole discretion and risk. AllGuard.io shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use or inability to use this site. You agree to indemnify AllGuard.io against any losses, damages, or expenses—including legal fees—resulting from misuse of our content or services.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Limitation of Liability</h2>
    <p>AllGuard.io is not liable for any damages—including loss of data, profits, or business opportunities—whether foreseeable or not, to the maximum extent permitted by law. This limitation may not apply where jurisdictions prohibit such exclusions.</p>
</div>

<div className="item-details-widget">
    <h2 className="item_details_info_title">Contact</h2>
    <p>For questions about these Terms & Conditions or related matters, please <Link onClick={ClickHandler} to="/contact" className="details-link">click here</Link> to reach us. Alternatively, you may email us at: <a href="mailto:hello@allguard.io">hello@allguard.io</a>.</p>
</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <CtaSection cClass={'bg'}/>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default TermsPage;
